/**
 * @license lucide v0.577.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

const Form = [
  ["path", { d: "M4 14h6" }],
  ["path", { d: "M4 2h10" }],
  ["rect", { x: "4", y: "18", width: "16", height: "4", rx: "1" }],
  ["rect", { x: "4", y: "6", width: "16", height: "4", rx: "1" }]
];

export { Form as default };
//# sourceMappingURL=form.js.map
